var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    "aria-labelledby": "clockIcon clockDesc"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M17.242 31.508c7.878 0 14.266-6.388 14.266-14.266 0-7.877-6.388-14.265-14.266-14.265-7.877 0-14.265 6.388-14.265 14.265 0 7.878 6.388 14.266 14.265 14.266zm0 2.5C7.984 34.008.477 26.5.477 17.242S7.984.477 17.242.477c9.259 0 16.766 7.507 16.766 16.765 0 9.259-7.507 16.766-16.766 16.766zM24.186 21.1l-6.459-3.894V6.818h-2.424v11.758l7.633 4.6 1.25-2.075z"
  })));
}

export default SvgClock;